import { useContext, useEffect } from 'react';
import { Box, Grid2, styled } from '@mui/material';
import Context from '../../context';
import { useImageContext } from '../../imageContext';
import { useGetToken } from '../../hooks/useGetToken';
import { fbGetAdminImages } from '../../services/service';
import { ImageFolder } from '../ImageFolder';
import { ImageFile } from '../ImageFile';
import InputField from '../InputField';

const InputGrid = styled(Grid2)({
});

const ContainerGrid = styled(Grid2)({
  paddingTop: '5px',
});

const FileContainerTopGrid = styled(Grid2)({
  height: '500px',
});

const FileContainerGrid = styled(Grid2)({
  height: '500px',
  border: '1px solid lightgray',
  borderRadius: '3px',
  overflowY: 'auto',
});

export const ImageList = (): JSX.Element => {
  const { updateIsLoading, setShowError, setMessage: setErrorMessage  } = useContext(Context);
  const [getTokenFunction] = useGetToken();
  const {
    timestamp,
    itemList,
    setItemList,
    search,
    setSearch,
    listChanged,
    selected,
    setSelected,
  } = useImageContext();

  useEffect(() => {
    const getImageData = async () => {
      try {
        updateIsLoading(true);
        const accessToken = await getTokenFunction();
        const imageResultList: string[] | null = await fbGetAdminImages(
          accessToken
        );
        if (imageResultList) {
          setItemList(imageResultList);
        }
      } catch (e) {
        setErrorMessage(`fbGetAdminImages ${e}`)
        setShowError(true);
      } finally {
        updateIsLoading(false);
      }
    };
    getImageData();
    setSelected(selected);
  }, [listChanged, timestamp]);

  const ilSearchTitle = 'Search';
  const ilSearchBody = 'Use search to decrease the size of the image list. <><>Search is case insensitive.';

  const handleLockedFields = (
    field: string,
    locked: boolean
  ) => {
    console.error(`not used ${field} ${locked}`);
  }

  return (
    <>
      <Grid2 container>
        <InputGrid size={12}>
          <Box>
          <InputField
              labelText={'Search'}
              labelId={'search'}
              mandatory={false}
              helpTextTitle={ilSearchTitle}
              helpTextBody={ilSearchBody}
              value={search || ''}
              onChange={(value) => setSearch(value)}
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              onBlur={() => {}}
              fullWidth={true}
              error={false}
              disabled={false}
              displayedLock={false}
              onLock={handleLockedFields}
              disabledLock={true}
              isLocked={false}
            />
          </Box>
        </InputGrid>
        <ContainerGrid>&nbsp;</ContainerGrid>
        <FileContainerTopGrid container size={12} >
          <FileContainerGrid size={12}>
            {itemList.map((item) => {
              const match =
                search === '' ||
                item.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              if (match && item.endsWith('/')) {
                return <ImageFolder item={item} readOnly={false}/>;
              } else if (match && !item.endsWith('/')) {
                return <ImageFile item={item} readOnly={false} highlight={false}/>;
              }
            })}
          </FileContainerGrid>
        </FileContainerTopGrid>
      </Grid2>
    </>
  );
};
